var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 13 15",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.897,0.858c0.04,-0.34 -0.15,-0.667 -0.466,-0.799c-0.315,-0.132 -0.68,-0.037 -0.893,0.231l-6.372,8.061c-0.183,0.231 -0.217,0.546 -0.09,0.811c0.128,0.266 0.395,0.434 0.689,0.434l4.874,0c-0,0 -0.536,4.515 -0.536,4.515c-0.04,0.341 0.15,0.668 0.466,0.8c0.315,0.132 0.68,0.037 0.893,-0.232l6.372,-8.06c0.183,-0.231 0.217,-0.546 0.09,-0.811c-0.128,-0.266 -0.395,-0.434 -0.689,-0.434l-4.874,-0c0,-0 0.536,-4.516 0.536,-4.516Zm-1.838,2.509l-0.318,2.684c-0.026,0.218 0.042,0.436 0.187,0.6c0.145,0.164 0.353,0.258 0.572,0.258l4.152,0c0,0 -3.711,4.694 -3.711,4.694c0,0 0.318,-2.684 0.318,-2.684c0.026,-0.218 -0.042,-0.436 -0.187,-0.6c-0.145,-0.164 -0.353,-0.258 -0.572,-0.258l-4.152,-0l3.711,-4.694Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZap);
export default __webpack_public_path__ + "static/media/Zap.b0b5535c170301d37aedaf43c11165fc.svg";
export { ForwardRef as ReactComponent };